// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--NWk3I";
export var hero__img = "Hero-module--hero__img--ghBeJ";
export var hero__text = "Hero-module--hero__text--pCGKZ";
export var hero__title = "Hero-module--hero__title--aW7bq";
export var hero__videoIcon = "Hero-module--hero__videoIcon--KRzKX";
export var hero__videoLink = "Hero-module--hero__videoLink--3C2I3";
export var hero__videoText = "Hero-module--hero__videoText--+cEjX";